// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21C21 9 21 15 21 21H3V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 14H9V21H15V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 7.65685 16.3431 9 18 9C19.6569 9 21 7.65686 21 6V3H3V6Z"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15 14H9V21H15V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 7.65685 16.3431 9 18 9C19.6569 9 21 7.65685 21 6V3H3V6Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21C21 9 21 15 21 21H3V3Z","strokeWidth":"props.strokeWidth"}}]}]};

const Shop3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-3',
    ref,
    icon: element,
  },
));

Shop3Icon.displayName = 'Shop3Icon';

export default Shop3Icon;
